import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import SVG from 'react-inlinesvg';

import { getIconFilePath } from '../../../util/uri';

import SkeletonElement from '../../SkeletonElement';

const Icon = ({
    src,
    name,
    className,
    theme = {},
    loader = <SkeletonElement isLoading fullSize>X</SkeletonElement>,
}) => {
    if (!src && !name) {
        return null;
    }
    return (
        <span
            className={ classNames({
                [theme.icon]: true,
                [theme[className]]: className,
            }) }
        >
            <SVG
                loader={ loader }
                src={ src || getIconFilePath(name) }
                cacheRequests
            />
        </span>
    );
};

Icon.propTypes = {
    src: PropTypes.string,
    name: PropTypes.string,
    className: PropTypes.string,
    theme: PropTypes.shape({}),
    loader: PropTypes.node,
};

export default Icon;
